"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createItemDialog = void 0;

var React = require("react");

var maishu_ui_toolkit_1 = require("maishu-ui-toolkit");

var ReactDOM = require("react-dom");

var maishu_dilu_1 = require("maishu-dilu");

var input_control_1 = require("./inputs/input-control");

function createItemDialog(dataSource, name, child, beforeSave) {
  var ItemDialog = /*#__PURE__*/function (_React$Component) {
    _inherits(ItemDialog, _React$Component);

    var _super = _createSuper(ItemDialog);

    function ItemDialog(props) {
      var _this;

      _classCallCheck(this, ItemDialog);

      _this = _super.call(this, props);
      _this.state = {};
      _this.beforeSaves = [];
      _this.inputControls = [];
      child = _this.cloneElement(child);
      return _this;
    }
    /**
     * 克隆元素，并找出 InputControl
     * @param element 要克隆的元素
     */


    _createClass(ItemDialog, [{
      key: "cloneElement",
      value: function cloneElement(element) {
        var _this2 = this;

        if (element == null) return null;
        if (typeof element == "string") return element;

        if (Array.isArray(element)) {
          return element.map(function (o) {
            return _this2.cloneElement(o);
          });
        }

        var elementType = element["type"];
        console.assert(elementType);
        var props;
        var it = this;

        if (typeof elementType == "function") {
          if (elementType.constructor == input_control_1.InputControl.constructor) {
            var _ref = element.props.ref;
            props = Object.assign({}, element.props, {
              ref: function ref(e) {
                if (!e) return;
                it.inputControls.push(e);
                if (_ref) _ref.apply(this);
              }
            });
          }
        }

        props = props || element.props;
        var newChildren = this.cloneElement(element.props.children);
        var newElement;

        if (Array.isArray(newChildren)) {
          newElement = React.createElement.apply(React, [elementType, props].concat(_toConsumableArray(newChildren)));
        } else {
          newElement = React.createElement(elementType, props, newChildren);
        }

        return newElement;
      }
    }, {
      key: "onSaveButtonClick",
      value: function () {
        var _onSaveButtonClick = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  this.validator.clearErrors();

                  if (this.validator.check()) {
                    _context.next = 3;
                    break;
                  }

                  return _context.abrupt("return", Promise.reject('validate fail'));

                case 3:
                  _context.next = 5;
                  return this.save();

                case 5:
                  maishu_ui_toolkit_1.hideDialog(this.dialogElement);

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function onSaveButtonClick() {
          return _onSaveButtonClick.apply(this, arguments);
        }

        return onSaveButtonClick;
      }()
    }, {
      key: "setDataItem",
      value: function setDataItem(dataItem) {
        this.dataItem = dataItem;
        var primaryValues = (dataSource.primaryKeys || []).map(function (key) {
          return dataItem[key];
        }).filter(function (o) {
          return o;
        });
        var title = primaryValues.length > 0 ? "\u4FEE\u6539".concat(name) : "\u6DFB\u52A0".concat(name);
        this.inputControls.forEach(function (c) {
          var value = dataItem[c.props.dataField];
          c.value = value;
        });
        this.setState({
          title: title
        });
      }
    }, {
      key: "save",
      value: function () {
        var _save = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var dataItem, primaryValues;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  dataItem = this.dataItem;
                  this.inputControls.forEach(function (c) {
                    dataItem[c.props.dataField] = c.value;
                  });

                  if (!beforeSave) {
                    _context2.next = 5;
                    break;
                  }

                  _context2.next = 5;
                  return beforeSave(dataItem);

                case 5:
                  if (!(this.beforeSaves.length > 0)) {
                    _context2.next = 8;
                    break;
                  }

                  _context2.next = 8;
                  return Promise.all(this.beforeSaves.map(function (m) {
                    return m(dataItem);
                  }));

                case 8:
                  primaryValues = dataSource.primaryKeys.map(function (o) {
                    return dataItem[o];
                  }).filter(function (v) {
                    return v != null;
                  });

                  if (!(primaryValues.length > 0)) {
                    _context2.next = 14;
                    break;
                  }

                  _context2.next = 12;
                  return dataSource.update(dataItem);

                case 12:
                  _context2.next = 16;
                  break;

                case 14:
                  _context2.next = 16;
                  return dataSource.insert(dataItem);

                case 16:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function save() {
          return _save.apply(this, arguments);
        }

        return save;
      }()
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        var ctrls = this.inputControls;
        var validateFields = ctrls.filter(function (o) {
          return o.props.validateRules;
        }).map(function (o) {
          return {
            name: o.props.dataField,
            rules: o.props.validateRules
          };
        });
        this.validator = _construct(maishu_dilu_1.FormValidator, [this.fieldsConatiner].concat(_toConsumableArray(validateFields)));
      }
    }, {
      key: "render",
      value: function render() {
        var _this3 = this;

        var title = this.state.title;
        return React.createElement("div", {
          className: "modal-dialog"
        }, React.createElement("div", {
          className: "modal-content"
        }, React.createElement("div", {
          className: "modal-header"
        }, React.createElement("button", {
          type: "button",
          className: "close",
          "data-dismiss": "modal",
          "aria-label": "Close"
        }, React.createElement("span", {
          "aria-hidden": "true"
        }, "\xD7")), React.createElement("h4", {
          className: "modal-title"
        }, title)), React.createElement("div", {
          className: "modal-body well",
          style: {
            paddingLeft: 20,
            paddingRight: 20
          },
          ref: function ref(e) {
            return _this3.fieldsConatiner = e || _this3.fieldsConatiner;
          }
        }, child), React.createElement("div", {
          className: "modal-footer"
        }, React.createElement("button", {
          className: "btn btn-default",
          onClick: function onClick() {
            maishu_ui_toolkit_1.hideDialog(_this3.dialogElement);
          }
        }, React.createElement("i", {
          className: "icon-reply"
        }), React.createElement("span", null, "\u53D6\u6D88")), React.createElement("button", {
          className: "btn btn-primary",
          onClick: function onClick() {
            return _this3.onSaveButtonClick();
          }
        }, React.createElement("i", {
          className: "icon-save"
        }), React.createElement("span", null, "\u786E\u5B9A")))));
      }
    }], [{
      key: "show",
      value: function show(dataItem) {
        dataItem = dataItem || {};

        if (!ItemDialog.instance) {
          var dialogElement = document.createElement("div");
          dialogElement.className = "modal fade-in";
          document.body.appendChild(dialogElement);
          ItemDialog.instance = ReactDOM.render(React.createElement(ItemDialog, null), dialogElement);
          ItemDialog.instance.dialogElement = dialogElement;
        }

        if (ItemDialog.instance.validator) ItemDialog.instance.validator.clearErrors();
        ItemDialog.instance.setDataItem(dataItem);
        maishu_ui_toolkit_1.showDialog(ItemDialog.instance.dialogElement);
      }
    }]);

    return ItemDialog;
  }(React.Component);

  return ItemDialog;
}

exports.createItemDialog = createItemDialog;
